const styles = ({ typography }) => ({
  ...typography.h4,
});

export default styles;
